import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";
import { DEBOUNCE } from "../../../../../../../../../utils";
import { FEED_AUTO_COMPLETE } from "../../../../../../../../../actions/api";
import HttpClient from "../../../../../../../../../actions/http-client";
import SearchPlace from "../../../../../../Feeds/AddFeeds/Elements/SearchPlace";


class YelpFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            businessUrlError: false,
            businessUrl: '',
            location: '',
            locationError: false,
            keyword: '',
            keywordError: false,
            keywordErrorMsg: null,
            locationErrorMsg: null,
            keywordList: [],
            slug: null,
            latlng: "",
            isSelectedFromList: false,
            filterId: props.selectedFilterId
        }
    }

    autoComplete = DEBOUNCE((e) => {
        new HttpClient()
            .post(`${FEED_AUTO_COMPLETE}`, {
                handle: e.target.value,
                action: 1,
                networkId: 19,
                filterType: 28,
                Latlng: this.state.latlng
            })
            .then((response) => {
                const result = response.data;

                if (result.responseCode === 200) {
                    if (result.responseData && result.responseData.length > 0) {
                        this.setState({ keywordList: result.responseData });
                    } else {
                        this.setState({ keywordError: true, keywordErrorMsg: `Key Word Does't Available On This address` });
                    }
                }
            }).catch((ex) => {

            })
    });

    handleOnChange = (e) => {

        if (this.state.location) {
            if (e.target.name == "keyword") {
                if (e.target.value.length == 0) {
                    this.setState({ keywordList: [] });
                }
                if (e.target.value && e.target.value.length > 2) {
                    this.autoComplete(e);
                }
            }
            this.setState({ [e.target.name]: e.target.value, businessUrlError: false, isSelectedFromList: false, keywordError: false, keywordErrorMsg: null });
        } else {
            this.setState({ keywordError: true, keywordErrorMsg: `Please Select Location from dropdown then Fill Up Keyword` });
        }
    }

    keywordSelected = (item) => {
        this.setState({ keyword: item.data_handle_playlistName, isSelectedFromList: true, keywordList: [], slug: item.data_slug_alias, keywordError: false, keywordErrorMsg: null });
    }

    onTextFieldChange = (value) => this.setState({ location: value, locationError: false, locationErrorMsg: null, keywordError: false, keywordErrorMsg: null, latlng: null });
    onLatlanChange = (value) => this.setState({ latlng: value });

    onSubmit = () => {
        const { updateStep, selectedFilterId } = this.props;
        const { businessUrl, location, latlng, keyword, isSelectedFromList, slug } = this.state;


        if ((businessUrl == '' && selectedFilterId == 27)) {
            this.setState({ businessUrlError: true });
        } else if (location == '' && selectedFilterId == 28) {
            this.setState({ locationError: true });
        } else if (latlng == null && selectedFilterId == 28) {
            this.setState({ locationError: true, locationErrorMsg: "Please select an option" });
        } else if (keyword == '' && selectedFilterId == 28) {
            this.setState({ keywordError: true });
        } else {
            if (!isSelectedFromList && selectedFilterId == 28) {
                this.setState({ keywordError: true, keywordErrorMsg: "Please select an option" });
                return;
            }

            if (selectedFilterId == 27 && !businessUrl.includes("://")) {
                this.setState({ businessUrlError: true });
                return;
            }

            var obj = {
                networkId: 19,
                filter: selectedFilterId,
                businessPageUrl27: (selectedFilterId == 27) ? businessUrl : "",
                businessName28: (selectedFilterId == 28) ? location : '',
                businessKeywordfield28: (selectedFilterId == 28) ? keyword : '',
                businessKeyword28: (selectedFilterId == 28) ? slug : '',
                moderation: 0
            }

            if (selectedFilterId == 27) {
                obj['businessName28'] = '';
                obj['businessKeywordfield28'] = '';
                obj['businessKeyword28'] = '';
            } else if (selectedFilterId == 28) {
                obj['businessPageUrl27'] = '';
            }

            this.setState({ businessUrlError: false, locationError: false, keywordError: false, loading: true });

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.filterId != nextProps.selectedFilterId) {
            this.setState({ keywordList: [], keyword: '' });
        }
    }

    render() {
        const { businessUrl, keyword, businessUrlError, locationError, keywordError, locationErrorMsg, keywordErrorMsg, keywordList, loading } = this.state;
        const { selectedFilterId } = this.props;
        return (
            <div className="ob-feed-form-wrapper w-100">
                {selectedFilterId == 27 ? <div className="selectSource-right mb-3">
                    <div className="position-relative d-flex custom-input">
                        <span className="hastag d-flex align-items-center">
                            <i className={`fas fa-font`}></i>
                        </span>
                        <InputField name={"businessUrl"} placeholder="Enter business URL here.." className="form-control p-3" value={businessUrl} onChangeHandler={(e) => this.setState({ businessUrl: e.target.value, businessUrlError: false, isSelectedFromList: false, keywordError: false, keywordErrorMsg: null })} />
                    </div>
                    {businessUrlError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">Please Enter Business Page Url.</span>}
                </div> :
                    <div className="">
                        <div className="selectSource-right">
                            <div className="advance-input">
                                <SearchPlace onLatlanChange={this.onLatlanChange} onFieldTextChange={this.onTextFieldChange} error={locationError} />
                                {locationError && <span id="feed_searcherror text-left" className="errorMessage required">
                                    {locationErrorMsg ? locationErrorMsg : `This field is required`}</span>}
                            </div>
                        </div>
                        <div className="selectSource-right">
                            <div className="form-group position-relative advance-input custom-input">
                                <div className="position-relative d-flex">
                                    <span className="hastag d-flex align-items-center">
                                        <i className={`fas fa-font`}></i>
                                    </span>
                                    <InputField name={"keyword"} placeholder="Enter keyword here.." className="form-control p-3" value={keyword} onChangeHandler={(e) => this.handleOnChange(e)} autoComplete={true} />
                                </div>
                                {(keywordList && keywordList.length > 0) && <div className={`dropdown-menu ${(keywordList && keywordList.length > 0) ? "show" : ''} handlelist`} >
                                    <ul className="list-unstyled">
                                        {keywordList.map((item) => <li data-handle={item.url} data-slug={item.data_slug_alias} onClick={() => this.keywordSelected(item)} key={item.data_slug_alias}>
                                            <div className='d-flex align-items-center'>
                                                <div className="img-card">
                                                    <img src={item.image_url} alt={item.data_handle_playlistName} className="img-fluid" />
                                                </div>
                                                <div className="img-text">{item.url}<br /><span>{item.data_handle_playlistName}</span></div>
                                            </div>
                                        </li>)}
                                    </ul>
                                </div>}
                                {keywordError && <span id="feedsy_searcherror" className="errorMessage required">
                                    {keywordErrorMsg ? keywordErrorMsg : `This field is required`}</span>}
                            </div>
                            <div className="wrap_yelp_sugg"> </div>
                        </div>
                    </div>}
                <div className="click-next d-flex align-items-center justify-content-between py-3 px-3 rounded">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 27 ? !businessUrl.trim() : !keyword.trim()} />
                </div>
            </div>
        )
    }
}

export default YelpFeed;